import React from 'react';
import PropTypes from 'prop-types';
import Pictogram from '../global/pictogram';
import LoadingComponent from '../global/loading-component';
import TranslatedCopy from '../../intl/translated-copy';
function IropsManageBookedInformation(props) {
  const { loaderIcon } = props;
  return (
    <div className='booking-space-container'>
      <div className='iropsatc-content-wrapper'>
        <div className='iropsatc-conetnt-header'>
          <TranslatedCopy
            className='iropsatc-header-message'
            copyID='MYB_STATUS_OF_RESERVATION'
            tagName='p'
          />
        </div>
        <div className='iropsatc-booked-list'>
          { !loaderIcon ? 
            <div className='iropsatc-list'>
              <div className='iropsatc-list-details'>
                <Pictogram
                  className='iropsatc-no-info'
                  id='noIropsatclist'
                />
              </div>
              <div className='iropsatc-no-message-info'>
                <TranslatedCopy
                  className='iropsatc-no-message'
                  copyID='MYB_NO_REGISTERED_RESERVATIONS'
                  tagName='p'
                />
              </div>
            </div> :
            <div className='loading-section'>
              <div className='loading-message'>
                <TranslatedCopy
                  className='loading-message-1'
                  copyID='MYB_DO_NOT_CLOSE_THE_WINDOW'
                  tagName='p'
                />
                <TranslatedCopy
                  className='loading-message-2'
                  copyID='MYB_LOOKING_FOR_RESERVATION'
                  tagName='p'
                />
              </div>
              <div className='loader-icon'>
                <LoadingComponent increaseLoaderSize={ true } />
              </div>                 
            </div> 
          }
        </div>      
      </div>
    </div>
  );
}

IropsManageBookedInformation.propTypes = {
  loaderIcon: PropTypes.bool,
};

IropsManageBookedInformation.defaultProps = {
  loaderIcon: false,
};

export default IropsManageBookedInformation;